import { useCallback, useState } from 'react';

import { ShippingOption } from 'common/api/e-comm/orders/service';
import { getEstimatedShipDate, ShipDateEstimation } from 'common/api/fulfillment/shipping/service';
import { fromEntries } from 'common/utils';
import { PartialRecord } from 'common/definitions/PartialRecord';
import { asTuple } from 'common/utils/asTuple';
import { APIResponse } from 'common/api/models';

export const useShipDateEstimations = () => {
    const [estimationResponses, setEstimationResponses] = useState<
        PartialRecord<ShippingOption['name'], APIResponse<ShipDateEstimation>>
    >({});

    return {
        estimationResponses,
        loadShipDateEstimations: useCallback(
            async (shippingOptions: ShippingOption[], orderSubtotal: number) => {
                const entries = await Promise.all(
                    shippingOptions.map(async ({ name }) => {
                        const response = await getEstimatedShipDate(name, orderSubtotal);
                        return asTuple(name, response);
                    })
                );
                setEstimationResponses(fromEntries(entries));
            },
            []
        ),
    };
};
